import React from 'react';
import { FC } from 'react';

const CrossIconSvg: FC<{
  size?: string;
  color?: string;
  crosIconHandler?: (event: React.MouseEvent) => void;
  fill?: string;
  className?: string;
}> = ({ size = '16', crosIconHandler, fill, color, className }) => {
  return (
    <svg
      className={className}
      onClick={crosIconHandler}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={fill || 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M15 1L1 15M1 1L15 15"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default CrossIconSvg;
